<template>
  <v-flex>
    <vue-markdown
      class="mb-4 px-2"
      :html="true"
      v-if="getTemplateByName('FOURTH_STEP_HEADER_CONTENT') != null"
    >{{getTemplateByName("FOURTH_STEP_HEADER_CONTENT").content}}</vue-markdown>
    <v-flex v-if="isCompany || (!isCompany && !this.paymentCardIsShown())">
      <v-flex class="mx-2" style="text-align: center;">
        <div class="row item-padding">
          <v-flex></v-flex>
          <v-flex xs7 sm6 md6 class="type-value grey--text">Sub Total</v-flex>
          <v-flex xs5 sm6 md6>{{subTotal}}</v-flex>
        </div>
        <v-divider></v-divider>
        <div class="row item-padding">
          <v-flex xs7 sm6 md6 class="type-value grey--text">VAT</v-flex>
          <v-flex xs5 sm6 md6>{{totalVat}}</v-flex>
        </div>
        <v-divider></v-divider>
        <div class="row item-padding" style="font-weight: bold;">
          <v-flex xs7 sm6 md6>Total Price (incl. VAT)</v-flex>
          <v-flex xs5 sm6 md6>{{totalPrice}}</v-flex>
        </div>
      </v-flex>

      <v-flex class="mx-2 mt-5 mb-2">Payment Options:</v-flex>

      <v-row class="text-center ma-1">
        <v-flex
          v-if="bankTransferIsShown()"
          :sm6="paymentCardIsShown()"
          :sm12="!paymentCardIsShown()"
          :md6="paymentCardIsShown()"
          :md12="!paymentCardIsShown()"
        >
          <v-card class="mx-1 my-2 pa-2">
            <v-card-title class="px-2 justify-center">
              <div style="flex-basis: 100%;">Bank Transfer</div>
              <v-img
                alt="By Invoice"
                style="flex-basis: 100%;"
                class="mt-2"
                :src="this.isPlugin ? '../wp-content/plugins/ticket-checkout/dist/statics/invoice_icon.svg' : '/statics/invoice_icon.svg'"
                :max-width="$vuetify.breakpoint.smAndDown ? 45 : 57"
                :max-height="$vuetify.breakpoint.smAndDown ? 27 : 34"
                aspect-ratio="1"
              ></v-img>
            </v-card-title>
            <v-card-text class="py-2">
              <vue-markdown
                :html="true"
                v-if="getTemplateByName('FOURTH_STEP_BANK_TRANSFER_CONTENT') != null"
              >{{getTemplateByName("FOURTH_STEP_BANK_TRANSFER_CONTENT").content}}</vue-markdown>
            </v-card-text>
            <v-btn
              class="mb-2"
              large
              color="primary"
              :disabled="this.tickets.length === 0 || widgetShow"
              @click="paymentInvoiceButtonActions"
            >Pay using bank transfer</v-btn>
          </v-card>
        </v-flex>

        <v-flex
          v-if="paymentCardIsShown()"
          xs12
          :sm6="bankTransferIsShown()"
          :sm12="!bankTransferIsShown()"
          :md6="bankTransferIsShown()"
          :md12="!bankTransferIsShown()"
        >
          <v-card class="mx-1 my-2 pa-2">
            <v-card-title class="justify-center">
              <div style="flex-basis: 100%;">Payment Card</div>
              <v-img
                alt="Verified by VISA"
                class="ml-3 mt-2"
                :src="this.isPlugin ? '../wp-content/plugins/ticket-checkout/dist/statics/visa_logo.webp' : '/statics/visa_logo.webp'"
                :max-width="$vuetify.breakpoint.smAndDown ? 48 : 61"
                :max-height="$vuetify.breakpoint.smAndDown ? 27 : 34"
                aspect-ratio="1"
              ></v-img>
              <v-img
                alt="MasterCard SecureCode"
                class="ml-3 mt-2"
                :src="this.isPlugin ? '../wp-content/plugins/ticket-checkout/dist/statics/mastercard_logo.jpg' : '/statics/mastercard_logo.jpg'"
                :max-width="$vuetify.breakpoint.smAndDown ? 48 : 61"
                :max-height="$vuetify.breakpoint.smAndDown ? 27 : 34"
                aspect-ratio="1"
              ></v-img>
            </v-card-title>
            <v-card-text class="py-2">
              <vue-markdown
                :html="true"
                v-if="getTemplateByName('FOURTH_STEP_PAYMENT_CARD_CONTENT') != null"
              >{{getTemplateByName("FOURTH_STEP_PAYMENT_CARD_CONTENT").content}}</vue-markdown>
            </v-card-text>
            <v-btn
              class="mb-2 white--text"
              large
              color="red"
              :disabled="this.tickets.length === 0 || widgetShow"
              @click="paymentCardButtonActions"
            >Pay Using Payment card</v-btn>
          </v-card>
        </v-flex>
      </v-row>
    </v-flex>

    <vue-markdown
      class="text-italic-grey mb-0 mx-2"
      :html="true"
      v-if="getTemplateByName('FOURTH_STEP_CONTACT_INFO_CONTENT') != null"
    >{{getTemplateByName("FOURTH_STEP_CONTACT_INFO_CONTENT").content}}</vue-markdown>
    <template v-if="widgetShow">
      <v-card class="ma-2 pa-2">
        <template v-if="isCompany || (!isCompany && !this.paymentCardIsShown())">
          <klix-checkout
            language="en"
            id="my-checkout-widget"
            :widget-id="getPropertyByName('KLIX_WIDGET_ID').textValue"
            :first-name="firstName"
            :last-name="lastName"
            :phone="sanitizedPhone"
            :email="email"
            lazy="true"
          ></klix-checkout>
        </template>
        <template v-else>
          <klix-checkout
            language="en"
            id="my-checkout-widget"
            :widget-id="getPropertyByName('KLIX_WIDGET_ID').textValue"
            :first-name="tickets.length === 1 ? tickets[0].firstName : null"
            :last-name="tickets.length === 1 ? tickets[0].lastName : null"
            :email="tickets.length === 1 ? tickets[0].email : null"
            lazy="true"
          ></klix-checkout>
        </template>
      </v-card>
    </template>
    <v-layout row>
      <div data-aos="fade-left" data-aos-offset="30">
        <v-btn
          class="ma-3"
          @click.native="moveToPreviousStep();showPayments = false; widgetShow = false;"
        >
          <v-icon left>navigate_before</v-icon>Back
        </v-btn>
      </div>
    </v-layout>
  </v-flex>
</template>

<script>
import helperMethods from "../mixins/helperMethods";
import storeData from "../mixins/storeData";
import VueMarkdown from "vue-markdown";
import totalPrices from "../mixins/totalPrices";
import paymentOptions from "../mixins/paymentOptions";

export default {
  components: {
    VueMarkdown
  },
  computed: {
    sanitizedPhone() {
      return this.phone.replace("+", "");
    }
  },
  mixins: [helperMethods, storeData, totalPrices, paymentOptions],
  methods: {
    moveToPreviousStep() {
      if (!this.isCompany && !this.paymentCardIsShown()) {
        this.currentStep = 3;
      } else if (!this.isCompany && this.paymentCardIsShown()) {
        this.currentStep = 2;
      } else {
        this.currentStep = 3;
      }

      this.showPayments = false;
      this.widgetShow = false;
      this.scrollToTop();
    },
    orderKlix() {
      this.$emit("change", {
        orderKlix: true
      });
    },
    showFinalizePopup() {
      this.$emit("change", {
        finalizePopupShow: true
      });
    },
    paymentCardButtonActions() {
      this.$gtm.trackEvent({
        category: "payment-card-button",
        action: "click",
        noninteraction: false
      });
      this.widgetShow = true;
      this.orderKlix();
    },
    paymentInvoiceButtonActions() {
      this.$gtm.trackEvent({
        category: "payment-invoice-button",
        action: "click",
        noninteraction: false
      });
      this.showFinalizePopup();
    }
  }
};
</script>

<style>
</style>